(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["_responsive-image"] && !Shopify.designMode) return;
  try {
    (function () {
  var CARD_SELECTOR = '.plp-item';
  var DEFERRED_SELECTOR = '[data-hover-srcset], [data-hover-src]';
  /* The hover layer is only ever revealed inside @media (hover: hover), so a
     tap on a touch device must not pull bytes that can never be displayed. */
  var hoverCapable = window.matchMedia ? window.matchMedia('(hover: hover)') : null;

  function promote(card) {
    if (card.dataset.hoverImagePromoted) {
      return;
    }
    var deferred = card.querySelectorAll(DEFERRED_SELECTOR);
    if (!deferred.length) {
      return;
    }
    card.dataset.hoverImagePromoted = 'true';
    for (var i = 0; i < deferred.length; i++) {
      var el = deferred[i];
      if (el.dataset.hoverSrcset) {
        el.setAttribute('srcset', el.dataset.hoverSrcset);
        el.removeAttribute('data-hover-srcset');
      }
      if (el.dataset.hoverSrc) {
        el.setAttribute('src', el.dataset.hoverSrc);
        el.removeAttribute('data-hover-src');
      }
    }
  }

  function onEnter(event) {
    if (hoverCapable && !hoverCapable.matches) {
      return;
    }
    var target = event.target;
    if (!target || typeof target.closest !== 'function') {
      return;
    }
    var card = target.closest(CARD_SELECTOR);
    if (card) {
      promote(card);
    }
  }

  document.addEventListener('pointerenter', onEnter, true);
  document.addEventListener('focusin', onEnter);
})();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["image-quote-slider-controls"] && !Shopify.designMode) return;
  try {
    document.addEventListener('DOMContentLoaded', function () {
    function initImageQuoteSliders() {
      var sliders = document.querySelectorAll('.js-image-quote-slider');
      if (!sliders.length) return;

      sliders.forEach(function (slider, index) {
        var enableSwiperDesktop = slider.getAttribute('data-enable-swiper-desktop') === 'true';
        var enableSwiperMobile = slider.getAttribute('data-enable-swiper-mobile') === 'true';
        var desktopColumns = parseInt(slider.getAttribute('data-desktop-columns') || '4');
        var mobileColumns = parseInt(slider.getAttribute('data-mobile-columns') || '2');
        var isDesktop = window.innerWidth >= 750;
        var autoplay = slider.getAttribute('data-autoplay') === 'true';
        var autoplayDelay = parseInt(slider.getAttribute('data-autoplay-delay') || '5') * 1000;

        var shouldInitSwiper = (isDesktop && enableSwiperDesktop) || (!isDesktop && enableSwiperMobile);

        if (slider.swiper && !shouldInitSwiper) {
          slider.swiper.destroy(true, true);
          slider.swiper = null;
        }

        if (!shouldInitSwiper) return;

        if (!slider.swiper) {
          slider.classList.add('iqs' + index);

          var container = slider.parentElement;
          var nextEl = container ? container.querySelector('.js-iqs-btn.swiper-button-next') : null;
          var prevEl = container ? container.querySelector('.js-iqs-btn.swiper-button-prev') : null;
          var paginationEl = container ? container.querySelector('.js-iqs-pagination.swiper-pagination') : null;
          var autoplayToggle = container ? container.querySelector('[data-iqs-autoplay-toggle]') : null;
          var shouldLoop = slider.getAttribute('data-loop') === 'true';
          var mobileSlidesPerView = mobileColumns === 1 ? 1.25 : mobileColumns;
          var reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');
          var userPaused = false;

          /* Duplicate slides if not enough for centeredSlides loop */
          if (shouldLoop) {
            var wrapper = slider.querySelector('.swiper-wrapper');
            var originalSlides = wrapper.querySelectorAll('.swiper-slide');
            var originalCount = originalSlides.length;
            var maxPerView = Math.max(desktopColumns, Math.ceil(mobileSlidesPerView));
            var minNeeded = maxPerView * 2 + 1;

            if (originalCount > 0 && originalCount < minNeeded) {
              var multiplier = Math.ceil(minNeeded / originalCount) + 1;
              var targetCount = originalCount * multiplier;

              for (var r = 1; r < multiplier; r++) {
                for (var s = 0; s < originalCount; s++) {
                  var clone = originalSlides[s].cloneNode(true);
                  clone.removeAttribute('id');
                  clone.setAttribute('data-cloned', 'true');
                  wrapper.appendChild(clone);
                }
              }
            }
          }

          /* Find quote container */
          var section = slider.closest('.iqs');
          var quoteContainer = section ? section.querySelector('[data-quote-container]') : null;
          var quotes = quoteContainer ? quoteContainer.querySelectorAll('.iqs__quote') : [];
          var originalSlideCount = parseInt(slider.getAttribute('data-total-slides') || '0');

          function syncAccessibility(sw) {
            var slideId = slider.id;
            if (prevEl) {
              prevEl.setAttribute('aria-controls', slideId);
              prevEl.setAttribute('aria-disabled', prevEl.classList.contains('swiper-button-disabled') ? 'true' : 'false');
            }
            if (nextEl) {
              nextEl.setAttribute('aria-controls', slideId);
              nextEl.setAttribute('aria-disabled', nextEl.classList.contains('swiper-button-disabled') ? 'true' : 'false');
            }
            for (var i = 0; i < sw.slides.length; i++) {
              var slide = sw.slides[i];
              var isVisible = slide.classList.contains('swiper-slide-visible');
              slide.setAttribute('aria-hidden', isVisible ? 'false' : 'true');
              slide.inert = !isVisible;
            }
            if (paginationEl) {
              var bullets = paginationEl.querySelectorAll('button');
              for (var j = 0; j < bullets.length; j++) {
                bullets[j].setAttribute('aria-pressed', j === sw.realIndex ? 'true' : 'false');
              }
            }
          }

          function syncAutoplayToggle(sw) {
            if (!autoplayToggle) return;
            var isRunning = !!(sw.autoplay && sw.autoplay.running);
            autoplayToggle.setAttribute('data-paused', isRunning ? 'false' : 'true');
            autoplayToggle.setAttribute('aria-label', isRunning ? 'Pause image quote carousel' : 'Play image quote carousel');
            autoplayToggle.setAttribute('aria-controls', slider.id);
          }

          function stopAutoplay(sw) {
            if (sw.autoplay) sw.autoplay.stop();
            syncAutoplayToggle(sw);
          }

          function startAutoplay(sw) {
            if (!userPaused && !reducedMotion.matches && sw.autoplay) sw.autoplay.start();
            syncAutoplayToggle(sw);
          }

          function updateActiveQuote(realIndex) {
            if (!quotes.length) return;
            var mappedIndex = originalSlideCount > 0 ? realIndex % originalSlideCount : realIndex;
            for (var i = 0; i < quotes.length; i++) {
              quotes[i].classList.remove('iqs__quote--active');
            }
            var target = quoteContainer.querySelector('[data-quote-index="' + mappedIndex + '"]');
            if (target) {
              target.classList.add('iqs__quote--active');
            }
          }

          var swiperConfig = {
            slidesPerView: isDesktop ? desktopColumns : mobileSlidesPerView,
            spaceBetween: isDesktop ? 30 : 16,
            speed: 300,
            breakpointsBase: 'container',
            cssMode: false,
            loop: shouldLoop,
            loopAdditionalSlides: Math.max(desktopColumns, Math.ceil(mobileSlidesPerView)),
            centeredSlides: true,
            watchSlidesProgress: true,
            watchOverflow: false,
            a11y: {
              containerRoleDescriptionMessage: 'carousel',
              itemRoleDescriptionMessage: 'slide',
              slideLabelMessage: 'Image quote \u007b\u007bindex\u007d\u007d of \u007b\u007bslidesLength\u007d\u007d',
              prevSlideMessage: 'Previous image quote',
              nextSlideMessage: 'Next image quote',
            },
            passiveListeners: true,
            shortSwipes: true,
            threshold: 10,
            touchAngle: 75,
            touchMoveStopPropagation: true,
            mousewheel: {
              releaseOnEdges: false,
              forceToAxis: true,
              sensitivity: 0.25,
            },
            breakpoints: {
              750: {
                slidesPerView: desktopColumns,
                spaceBetween: 30,
                centeredSlides: true,
              },
              480: {
                slidesPerView: mobileColumns === 1 ? 1.25 : mobileColumns,
                spaceBetween: 16,
                centeredSlides: true,
              },
              0: {
                slidesPerView: mobileColumns === 1 ? 1.25 : mobileColumns,
                spaceBetween: 16,
                centeredSlides: true,
              }
            },
            navigation: {
              nextEl: nextEl,
              prevEl: prevEl,
            },
            pagination: {
              el: paginationEl,
              clickable: true,
              renderBullet: function (index, className) {
                return '<button type="button" class="' + className + '" aria-label="Go to slide ' + (index + 1) + ' of ' + originalSlideCount + '"></button>';
              },
            },
            on: {
              init: function (sw) {
                if (sw.params.loop) {
                  if (prevEl) prevEl.classList.remove('swiper-button-disabled');
                  if (nextEl) nextEl.classList.remove('swiper-button-disabled');
                  if (sw.navigation && sw.navigation.update) sw.navigation.update();
                }
                updateActiveQuote(sw.realIndex);
                syncAccessibility(sw);
                syncAutoplayToggle(sw);
              },
              slideChange: function (sw) {
                updateActiveQuote(sw.realIndex);
                syncAccessibility(sw);
              },
              update: function (sw) {
                syncAccessibility(sw);
              },
            },
          };

          if (autoplay && !reducedMotion.matches) {
            swiperConfig.autoplay = {
              delay: autoplayDelay,
              disableOnInteraction: false,
              pauseOnMouseEnter: true,
            };
          }

          var swiper = new Swiper(slider, swiperConfig);

          if (autoplayToggle) {
            autoplayToggle.addEventListener('click', function () {
              userPaused = !userPaused;
              if (userPaused) {
                stopAutoplay(swiper);
              } else {
                startAutoplay(swiper);
              }
            });
          }

          slider.addEventListener('focusin', function () {
            userPaused = true;
            stopAutoplay(swiper);
          });

          slider.addEventListener('focusout', function () {
            window.setTimeout(function () {
              if (!slider.contains(document.activeElement)) startAutoplay(swiper);
            }, 0);
          });

          reducedMotion.addEventListener('change', function () {
            if (reducedMotion.matches) {
              stopAutoplay(swiper);
            } else {
              startAutoplay(swiper);
            }
          });
        }
      });
    }

    initImageQuoteSliders();

    var resizeTimer;
    window.addEventListener('resize', function () {
      clearTimeout(resizeTimer);
      resizeTimer = setTimeout(function () {
        initImageQuoteSliders();
      }, 250);
    });
  });
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["image-slider-controls"] && !Shopify.designMode) return;
  try {
    document.addEventListener('DOMContentLoaded', function () {
    function initializeImageSliders() {
      var sliders = document.querySelectorAll('.js-image-slider');
      
      if (!sliders.length) return;
      
      sliders.forEach(function (slider, index) {
        // Get settings from data attributes
        var enableSwiperDesktop = slider.getAttribute('data-enable-swiper-desktop') === 'true';
        var enableSwiperMobile = slider.getAttribute('data-enable-swiper-mobile') === 'true';
        var desktopColumns = parseInt(slider.getAttribute('data-desktop-columns') || '4');
        var mobileColumns = parseInt(slider.getAttribute('data-mobile-columns') || '2');
        var isDesktop = window.innerWidth >= 750;
        var autoplay = slider.getAttribute('data-autoplay') === 'true';
        var autoplayDelay = parseInt(slider.getAttribute('data-autoplay-delay') || '5') * 1000;
        
        // Determine if we should initialize swiper
        var shouldInitSwiper = (isDesktop && enableSwiperDesktop) || (!isDesktop && enableSwiperMobile);
        
        // Clean up existing swiper if needed
        if (slider.swiper && !shouldInitSwiper) {
          slider.swiper.destroy(true, true);
          slider.swiper = null;
        }
        
        if (!shouldInitSwiper) return;
        
        // Only initialize if we don't already have a swiper instance
        if (!slider.swiper) {
          var slideCount = slider.querySelectorAll('.swiper-slide').length;
          slider.classList.add('is' + index);
          
          var container = slider.parentElement;
          var nextEl = container ? container.querySelector('.js-image-slider-btn.swiper-button-next') : null;
          var prevEl = container ? container.querySelector('.js-image-slider-btn.swiper-button-prev') : null;
          var paginationEl = container ? container.querySelector('.js-image-slider-pagination.swiper-pagination') : null;
          var shouldLoop = slider.getAttribute('data-loop') === 'true';
          
          // Adjust slidesPerView for mobile when set to 1 column
          var mobileSlidesPerView = mobileColumns === 1 ? 1.25 : mobileColumns;
          
          var swiperConfig = {
            slidesPerView: isDesktop ? desktopColumns : mobileSlidesPerView,
            spaceBetween: isDesktop ? 30 : 16,
            speed: 300,
            breakpointsBase: 'container',
            cssMode: false,
            loop: shouldLoop,
            centeredSlides: !isDesktop && mobileColumns === 1,
            watchOverflow: false,
            watchSlidesProgress: true,
            a11y: {
              containerRoleDescriptionMessage: 'carousel',
              itemRoleDescriptionMessage: 'slide',
              slideLabelMessage: 'Image \u007b\u007bindex\u007d\u007d of \u007b\u007bslidesLength\u007d\u007d',
              prevSlideMessage: 'Previous image',
              nextSlideMessage: 'Next image',
            },
            passiveListeners: true,
            shortSwipes: true,
            threshold: 10,
            touchAngle: 75,
            touchMoveStopPropagation: true,
            mousewheel: {
              releaseOnEdges: false,
              forceToAxis: true,
              sensitivity: 0.25,
            },
            breakpoints: {
              750: {
                slidesPerView: desktopColumns,
                spaceBetween: 30,
                centeredSlides: false,
              },
              480: {
                slidesPerView: mobileColumns === 1 ? 1.25 : mobileColumns,
                spaceBetween: 16,
                centeredSlides: mobileColumns === 1,
              },
              0: {
                slidesPerView: mobileColumns === 1 ? 1.25 : mobileColumns,
                spaceBetween: 16,
                centeredSlides: mobileColumns === 1,
              }
            },
            navigation: {
              nextEl: nextEl,
              prevEl: prevEl,
            },
            pagination: {
              el: paginationEl,
              clickable: true,
              renderBullet: function (bulletIndex, className) {
                return '<button type="button" class="' + className + '" aria-label="Go to slide ' + (bulletIndex + 1) + ' of ' + slideCount + '"></button>';
              },
            },
            on: {
              init: function (sw) {
                if (sw.params.loop) {
                  if (prevEl) prevEl.classList.remove('swiper-button-disabled');
                  if (nextEl) nextEl.classList.remove('swiper-button-disabled');
                  if (sw.navigation && sw.navigation.update) sw.navigation.update();
                }
                syncPagination(sw);
              },
              slideChange: function (sw) {
                syncPagination(sw);
              },
            },
          };
          
          // Add autoplay if enabled
          if (autoplay) {
            swiperConfig.autoplay = {
              delay: autoplayDelay,
              disableOnInteraction: false,
              pauseOnMouseEnter: true,
            };
          }
          
          var swiper = new Swiper(slider, swiperConfig);

          function syncPagination(sw) {
            if (!paginationEl) return;

            var bullets = paginationEl.querySelectorAll('.swiper-pagination-bullet');

            bullets.forEach(function (bullet, bulletIndex) {
              bullet.setAttribute('aria-pressed', bulletIndex === sw.realIndex ? 'true' : 'false');
            });
          }

        }
      });
    }
    
    // Initialize on load
    initializeImageSliders();
    
    // Re-initialize on resize to handle desktop/mobile switching
    var resizeTimer;
    window.addEventListener('resize', function() {
      clearTimeout(resizeTimer);
      resizeTimer = setTimeout(function() {
        initializeImageSliders();
      }, 250);
    });
  });
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["interactive-media"] && !Shopify.designMode) return;
  try {
    function initializeInteractiveMediaMotionControls() {
    var reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');
    var mediaGroups = document.querySelectorAll('[data-interactive-media]');

    mediaGroups.forEach(function (mediaGroup) {
      var video = mediaGroup.querySelector('.interactive-media__video');
      var button = mediaGroup.querySelector('.interactive-media__motion-toggle');

      if (!video || !button || button.dataset.motionControlInitialized === 'true') return;

      button.dataset.motionControlInitialized = 'true';

      function updateControl() {
        var isPlaying = !video.paused && !video.ended;
        button.setAttribute('data-paused', isPlaying ? 'false' : 'true');
        button.setAttribute('aria-label', isPlaying ? 'Pause motion' : 'Play motion');
      }

      function respectReducedMotion() {
        if (reducedMotion.matches) video.pause();
        updateControl();
      }

      button.addEventListener('click', function () {
        if (video.paused || video.ended) {
          video.play();
        } else {
          video.pause();
        }
      });

      video.addEventListener('play', updateControl);
      video.addEventListener('pause', updateControl);
      reducedMotion.addEventListener('change', respectReducedMotion);
      respectReducedMotion();
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initializeInteractiveMediaMotionControls);
  } else {
    initializeInteractiveMediaMotionControls();
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["product-carousel-controls"] && !Shopify.designMode) return;
  try {
    document.addEventListener('DOMContentLoaded', function () {
    function initializeCarousels() {
      var carousels = document.querySelectorAll('.js-products-carousel');
      
      if (!carousels.length) return;
      
      carousels.forEach(function (carousel, index) {
        // Get settings from data attributes
        var enableSwiperDesktop = carousel.getAttribute('data-enable-swiper-desktop') === 'true';
        var enableSwiperMobile = carousel.getAttribute('data-enable-swiper-mobile') === 'true';
        var isDesktop = window.innerWidth >= 750;
        
        // Determine if we should initialize swiper
        var shouldInitSwiper = (isDesktop && enableSwiperDesktop) || (!isDesktop && enableSwiperMobile);
        
        // Clean up existing swiper if needed
        if (carousel.swiper && !shouldInitSwiper) {
          carousel.swiper.destroy(true, true);
          carousel.swiper = null;
          carousel.removeAttribute('role');
          carousel.removeAttribute('aria-roledescription');
          carousel.removeAttribute('aria-label');
        }
        
        if (!shouldInitSwiper) return;
        
        // Only initialize if we don't already have a swiper instance
        if (!carousel.swiper) {
          var slideCount = carousel.querySelectorAll('.swiper-slide').length;
          var carouselLabel = carousel.getAttribute('data-carousel-label') || 'Products';
          carousel.classList.add('s' + index);
          carousel.setAttribute('role', 'group');
          carousel.setAttribute('aria-roledescription', 'carousel');
          carousel.setAttribute('aria-label', carouselLabel);
          
          var container = carousel.parentElement;
          var nextEl = container ? container.querySelector('.js-products-carousel-btn.swiper-button-next') : null;
          var prevEl = container ? container.querySelector('.js-products-carousel-btn.swiper-button-prev') : null;
          var shouldLoop = carousel.getAttribute('data-loop') === 'true' && slideCount >= 6;
          
          var swiper = new Swiper(carousel, {
            slidesPerView: 'auto',
            centeredSlides: true,
            speed: 300,
            breakpointsBase: 'container',
            cssMode: false,
            loop: shouldLoop,
            watchOverflow: false,
            passiveListeners: true,
            shortSwipes: true,
            threshold: 10,
            touchAngle: 75,
            touchMoveStopPropagation: true,
            watchSlidesProgress: true,
            a11y: {
              containerMessage: carouselLabel,
              containerRoleDescriptionMessage: 'carousel',
              itemRoleDescriptionMessage: 'slide',
              slideRole: 'listitem',
              slideLabelMessage: 'Product \u007b\u007bindex\u007d\u007d of \u007b\u007bslidesLength\u007d\u007d',
              prevSlideMessage: 'Previous product',
              nextSlideMessage: 'Next product',
            },
            mousewheel: {
              releaseOnEdges: false,
              forceToAxis: true,
              sensitivity: 0.25,
            },
            breakpoints: {
              480: {
                centeredSlides: false,
              },
            },
            navigation: {
              nextEl: nextEl,
              prevEl: prevEl,
            },
            on: {
              init: function (sw) {
                if (sw.params.loop) {
                  if (prevEl) prevEl.classList.remove('swiper-button-disabled');
                  if (nextEl) nextEl.classList.remove('swiper-button-disabled');
                  if (sw.navigation && sw.navigation.update) sw.navigation.update();
                }
                updateNavigationState(sw, prevEl, nextEl);
                updateSlideAccessibility(sw);
              },
              slideChange: function (sw) {
                updateNavigationState(sw, prevEl, nextEl);
                updateSlideAccessibility(sw);
              },
              update: function (sw) {
                updateNavigationState(sw, prevEl, nextEl);
                updateSlideAccessibility(sw);
              },
              resize: function (sw) {
                updateNavigationState(sw, prevEl, nextEl);
                updateSlideAccessibility(sw);
              },
            },
          });
        }
      });
    }


    function updateNavigationState(swiper, previousButton, nextButton) {
      if (previousButton) {
        previousButton.setAttribute('aria-disabled', !swiper.params.loop && swiper.isBeginning ? 'true' : 'false');
      }

      if (nextButton) {
        nextButton.setAttribute('aria-disabled', !swiper.params.loop && swiper.isEnd ? 'true' : 'false');
      }
    }

    /* Swiper emits slideChange once it has assigned the destination translate
       but while the wrapper is still animating from the previous position, so
       the rects are shifted by the remaining travel before they are judged. */
    function updateSlideAccessibility(swiper) {
      var carouselRect = swiper.el.getBoundingClientRect();
      var pendingShift = 0;

      if (typeof swiper.translate === 'number' && typeof swiper.getTranslate === 'function') {
        pendingShift = swiper.translate - swiper.getTranslate();
        if (swiper.rtlTranslate) pendingShift = -pendingShift;
        if (!isFinite(pendingShift)) pendingShift = 0;
      }

      swiper.slides.forEach(function (slide) {
        var slideRect = slide.getBoundingClientRect();
        var slideLeft = slideRect.left + pendingShift;
        var slideRight = slideRect.right + pendingShift;
        var isVisible = slide.classList.contains('swiper-slide-visible')
          && slideLeft >= carouselRect.left - 1
          && slideRight <= carouselRect.right + 1
          && slideRect.top >= carouselRect.top - 1
          && slideRect.bottom <= carouselRect.bottom + 1;

        slide.toggleAttribute('inert', !isVisible);
        slide.setAttribute('aria-hidden', isVisible ? 'false' : 'true');
      });
    }
    
    // Initialize on load
    initializeCarousels();
    
    // Re-initialize on resize to handle desktop/mobile switching
    var resizeTimer;
    window.addEventListener('resize', function() {
      clearTimeout(resizeTimer);
      resizeTimer = setTimeout(function() {
        initializeCarousels();
      }, 250);
    });
  });
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["terms-privacy-notice"] && !Shopify.designMode) return;
  try {
    (() => {
    function initializeTermsPrivacyNotice() {
    const STORAGE_KEY = 'yise_terms_privacy_notice_closed_2026_07_09';
    const NOTICE_VERSION = '2026-07-09';
    const notice = document.querySelector('[data-terms-privacy-notice]');
    const nativeBannerOverrideTemplate = document.querySelector('[data-cookie-banner-override-template]');
    if (!notice) {
      return;
    }

    const previewParams = new URLSearchParams(window.location.search);
    const previewThemeRole = window.Shopify && window.Shopify.theme ? window.Shopify.theme.role : '';
    const previewHostname = window.location.hostname;
    const isThemePreview =
      (previewThemeRole && previewThemeRole !== 'main') ||
      (window.Shopify && window.Shopify.designMode === true) ||
      previewHostname === '127.0.0.1' ||
      previewHostname === 'localhost' ||
      previewHostname.endsWith('.shopifypreview.com');
    const forceFallbackPreview =
      isThemePreview && previewParams.get('preview_terms_privacy') === '1';

    document.documentElement.classList.toggle('terms-privacy-preview-fallback', forceFallbackPreview);

    const optOutLink = notice.querySelector('[data-terms-privacy-opt-out]');
    const emailHashFromLiquid = notice.dataset.customerEmailSha256 || '';
    const customerEmailSha256 = /^[a-f0-9]{64}$/.test(emailHashFromLiquid) ? emailHashFromLiquid : '';
    notice.removeAttribute('data-customer-email-sha256');

    let nativeBanner = null;
    let nativeBannerWasVisible = false;
    let nativeBannerTracked = false;
    let nativeBannerObserver = null;
    let documentObserver = null;
    let privacyApiAttempts = 0;

    function readDismissedState() {
      try {
        return window.localStorage.getItem(STORAGE_KEY) === 'closed';
      } catch (error) {
        return false;
      }
    }

    function saveDismissedState() {
      try {
        window.localStorage.setItem(STORAGE_KEY, 'closed');
      } catch (error) {
        return;
      }
    }

    function getEmailHash() {
      return customerEmailSha256;
    }

    function dispatchNoticeEvent(eventName, surface, closeMethod) {
      const detail = {
        surface,
        noticeVersion: NOTICE_VERSION,
        pagePath: window.location.pathname,
        pageTitle: document.title,
        sha256EmailAddress: getEmailHash()
      };

      if (closeMethod) {
        detail.closeMethod = closeMethod;
      }

      const emitEvent = () => {
        document.dispatchEvent(new CustomEvent(eventName, { detail }));
      };

      if (window.yiseTermsPrivacyAnalyticsReady) {
        window.setTimeout(emitEvent, 0);
        return;
      }

      window.yisePendingTermsPrivacyEvents = window.yisePendingTermsPrivacyEvents || [];
      window.yisePendingTermsPrivacyEvents.push({ eventName, detail });
    }

    function isVisible(element) {
      if (!element || element.hidden) {
        return false;
      }

      const styles = window.getComputedStyle(element);
      return styles.display !== 'none' && styles.visibility !== 'hidden' && element.getClientRects().length > 0;
    }

    function updatePageLayerState() {
      const noticeIsVisible = isVisible(notice);
      const nativeIsVisible = isVisible(nativeBanner);
      const visibleHeights = [notice, nativeBanner]
        .filter(isVisible)
        .map((element) => element.getBoundingClientRect().height);
      document.documentElement.classList.toggle('terms-privacy-native-visible', nativeIsVisible);
      document.documentElement.classList.toggle('terms-privacy-visible', noticeIsVisible || nativeIsVisible);
      document.documentElement.style.setProperty(
        '--terms-privacy-visible-height',
        `${Math.max(0, ...visibleHeights)}px`
      );
    }

    /*
     * Give focus back when the notice closes.
     *
     * This deliberately does NOT pull focus in. The notice is a consent banner, not a dialog, and
     * moving focus to it when it appears interrupts whatever the shopper was reading — which is
     * what "Avoid autofocus on privacy notice" and the 2.4.11 remediation removed, on purpose.
     *
     * What went with it by accident was the other half. A keyboard user who tabs INTO the notice
     * and closes it is left with focus on <body>, so the next Tab restarts from the top of the
     * document and their place is gone (WCAG 2.4.3, Focus Order). Returning focus costs nothing
     * and interrupts nobody, because it only ever happens to focus the notice itself took.
     */
    let fallbackPreviousFocus = null;

    notice.addEventListener('focusin', (event) => {
      // Only the moment focus ENTERS from outside; moving between the notice's own buttons is not it.
      if (notice.contains(event.relatedTarget)) {
        return;
      }

      fallbackPreviousFocus = event.relatedTarget;
    });

    function restoreFallbackFocus() {
      const previous = fallbackPreviousFocus;
      fallbackPreviousFocus = null;
      if (!previous || typeof previous.focus !== 'function' || !previous.isConnected) {
        return;
      }

      previous.focus({ preventScroll: true });
    }

    function hideFallback() {
      const held = notice.contains(document.activeElement);
      notice.hidden = true;
      notice.setAttribute('aria-hidden', 'true');
      updatePageLayerState();

      /* Only hand focus back if the notice still had it. A shopper who clicked away and closed it
         from elsewhere should not be yanked back to where they were when they first tabbed in. */
      if (held) {
        restoreFallbackFocus();
      } else {
        fallbackPreviousFocus = null;
      }

      if (!nativeBanner && documentObserver) {
        documentObserver.disconnect();
        documentObserver = null;
      }
    }

    function closeFallback(closeMethod) {
      if (!isVisible(notice)) {
        return;
      }

      if (!forceFallbackPreview) {
        saveDismissedState();
      }
      dispatchNoticeEvent('terms-privacy:closed', 'fallback_popup', closeMethod);
      hideFallback();
    }

    function showFallback() {
      enhanceNativeBanner();

      if (!forceFallbackPreview && (readDismissedState() || isVisible(nativeBanner))) {
        return;
      }

      notice.hidden = false;
      notice.setAttribute('aria-hidden', 'false');
      updatePageLayerState();
      dispatchNoticeEvent('terms-privacy:shown', 'fallback_popup');
    }

    function hasSavedPrivacyDecision(customerPrivacy) {
      if (typeof customerPrivacy.currentVisitorConsent !== 'function') {
        return false;
      }

      const consent = customerPrivacy.currentVisitorConsent() || {};
      return ['analytics', 'marketing', 'preferences', 'sale_of_data'].some((key) => {
        const value = consent[key];
        return value === 'yes' || value === 'no' || value === true || value === false;
      });
    }

    function updateOptOutLink(customerPrivacy) {
      if (!optOutLink) {
        return;
      }

      let isOptOutAvailable = false;
      try {
        isOptOutAvailable =
          typeof customerPrivacy.saleOfDataRegion === 'function' && customerPrivacy.saleOfDataRegion() === true;
      } catch (error) {
        isOptOutAvailable = false;
      }

      optOutLink.hidden = !isOptOutAvailable;
      optOutLink.setAttribute('aria-hidden', isOptOutAvailable ? 'false' : 'true');
    }

    function checkNativeBannerVisibility() {
      const visible = isVisible(nativeBanner);

      if (visible && !nativeBannerWasVisible) {
        hideFallback();
        if (!nativeBannerTracked) {
          nativeBannerTracked = true;
          dispatchNoticeEvent('terms-privacy:shown', 'shopify_cookie_banner');
        }
      }

      nativeBannerWasVisible = visible;
      updatePageLayerState();
    }

    function handleNativeBannerClick(event) {
      const button = event.target.closest('button');
      if (!button) {
        return;
      }

      const closeMethods = {
        'shopify-pc__banner__btn-accept': 'accept',
        'shopify-pc__banner__btn-decline': 'decline',
        'shopify-pc__banner__btn-manage-prefs': 'manage_preferences'
      };
      const closeMethod = closeMethods[button.id];

      if (closeMethod) {
        dispatchNoticeEvent('terms-privacy:closed', 'shopify_cookie_banner', closeMethod);
        window.setTimeout(checkNativeBannerVisibility, 0);
      }
    }

    function enhanceNativeBanner() {
      const candidate = document.getElementById('shopify-pc__banner');
      if (!candidate) {
        return;
      }

      if (nativeBanner !== candidate) {
        nativeBanner = candidate;
        nativeBanner.addEventListener('click', handleNativeBannerClick, true);

        if (documentObserver) {
          documentObserver.disconnect();
          documentObserver = null;
        }

        if (nativeBannerObserver) {
          nativeBannerObserver.disconnect();
        }

        nativeBannerObserver = new MutationObserver(enhanceNativeBanner);
        nativeBannerObserver.observe(nativeBanner, {
          attributes: true,
          attributeFilter: ['class', 'hidden', 'style'],
          childList: true,
          subtree: true
        });
      }

      const body = nativeBanner.querySelector('.shopify-pc__banner__body');
      const nativeBannerCaption = body && body.querySelector('p');
      const cookieBannerCaptionOverride = nativeBannerOverrideTemplate &&
        nativeBannerOverrideTemplate.content.querySelector('[data-cookie-banner-override] p');
      if (
        nativeBannerCaption &&
        cookieBannerCaptionOverride &&
        !nativeBannerCaption.hasAttribute('data-cookie-banner-override')
      ) {
        const captionContent = cookieBannerCaptionOverride.cloneNode(true);
        nativeBannerCaption.replaceChildren(...captionContent.childNodes);
        nativeBannerCaption.setAttribute('data-cookie-banner-override', '');
      }

      checkNativeBannerVisibility();
    }

    function evaluateFallback() {
      const customerPrivacy = window.Shopify && window.Shopify.customerPrivacy;
      if (!customerPrivacy || typeof customerPrivacy.shouldShowBanner !== 'function') {
        privacyApiAttempts += 1;
        if (privacyApiAttempts < 50) {
          window.setTimeout(evaluateFallback, 100);
        }
        return;
      }

      enhanceNativeBanner();
      updateOptOutLink(customerPrivacy);

      if (forceFallbackPreview) {
        showFallback();
        return;
      }

      const isEligibleForCookieBanner = customerPrivacy.shouldShowBanner();
      const hasSavedDecision = hasSavedPrivacyDecision(customerPrivacy);
      const isIneligibleForCookieBanner = isEligibleForCookieBanner === false;

      if (isIneligibleForCookieBanner && !hasSavedDecision) {
        showFallback();
      }
    }

    notice.querySelectorAll('[data-terms-privacy-close]').forEach((button) => {
      button.addEventListener('click', () => {
        closeFallback(button.dataset.termsPrivacyClose);
      });
    });

    document.addEventListener('keydown', (event) => {
      if (event.key === 'Escape' && isVisible(notice)) {
        closeFallback('escape');
      }
    });

    document.addEventListener('visitorConsentCollected', () => {
      const customerPrivacy = window.Shopify && window.Shopify.customerPrivacy;
      if (customerPrivacy) {
        updateOptOutLink(customerPrivacy);
      }
    });

    documentObserver = new MutationObserver(enhanceNativeBanner);
    documentObserver.observe(document.documentElement, { childList: true, subtree: true });
    window.setTimeout(() => {
      if (documentObserver && !isVisible(notice)) {
        documentObserver.disconnect();
        documentObserver = null;
      }
    }, 10000);

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', evaluateFallback, { once: true });
    } else {
      evaluateFallback();
    }
    }

    function scheduleTermsPrivacyInitialization() {
      const AUTOMATIC_INITIALIZATION_DELAY = 31000;
      const INTENT_EVENTS = ['pointerdown', 'keydown', 'touchstart', 'wheel'];

      if (document.documentElement.hasAttribute('data-yise-automated-visitor')) {
        return;
      }

      let initializationScheduled = false;
      let automaticInitializationTimer = null;
      let pageLoaded = document.readyState === 'complete';

      function removeIntentListeners() {
        INTENT_EVENTS.forEach((eventName) => {
          window.removeEventListener(eventName, handleTrustedIntent);
        });
      }

      function runTermsPrivacyInitialization() {
        if (document.documentElement.hasAttribute('data-yise-automated-visitor')) {
          return;
        }

        initializeTermsPrivacyNotice();
      }

      function scheduleIdleInitialization() {
        if (initializationScheduled) {
          return;
        }

        initializationScheduled = true;
        removeIntentListeners();

        if (automaticInitializationTimer !== null) {
          window.clearTimeout(automaticInitializationTimer);
          automaticInitializationTimer = null;
        }

        if ('requestIdleCallback' in window) {
          window.requestIdleCallback(runTermsPrivacyInitialization, { timeout: 3000 });
        } else {
          window.setTimeout(runTermsPrivacyInitialization, 1);
        }
      }

      function handleTrustedIntent(event) {
        if (!event.isTrusted || !pageLoaded) {
          return;
        }

        scheduleIdleInitialization();
      }

      function scheduleBoundedInitialization() {
        pageLoaded = true;

        automaticInitializationTimer = window.setTimeout(
          scheduleIdleInitialization,
          AUTOMATIC_INITIALIZATION_DELAY
        );
      }

      INTENT_EVENTS.forEach((eventName) => {
        window.addEventListener(eventName, handleTrustedIntent, { passive: true });
      });

      if (document.readyState === 'complete') {
        scheduleBoundedInitialization();
      } else {
        window.addEventListener('load', scheduleBoundedInitialization, { once: true });
      }
    }

    scheduleTermsPrivacyInitialization();
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["video-modal"] && !Shopify.designMode) return;
  try {
    (function () {
    var READY = 'data-video-modal-ready';

    function startMedia(dialog) {
      var frame = dialog.querySelector('iframe[data-src]');
      if (frame && !frame.getAttribute('src')) {
        frame.setAttribute('src', frame.getAttribute('data-src'));
      }

      var video = dialog.querySelector('video');
      if (video) {
        var played = video.play();
        if (played && typeof played.catch === 'function') {
          played.catch(function () {});
        }
      }
    }

    function stopMedia(dialog) {
      var frame = dialog.querySelector('iframe[data-src]');
      if (frame) {
        frame.removeAttribute('src');
      }

      var video = dialog.querySelector('video');
      if (video) {
        video.pause();
        video.currentTime = 0;
      }
    }

    function connectDialog(dialog) {
      if (dialog.hasAttribute(READY)) return;
      dialog.setAttribute(READY, '');

      dialog.addEventListener('yise:dialog:open', function () {
        startMedia(dialog);
      });

      dialog.addEventListener('close', function () {
        stopMedia(dialog);
      });
    }

    function connectTrigger(element, dialogId) {
      if (!dialogId || element.hasAttribute(READY)) return;
      element.setAttribute(READY, '');
      element.setAttribute('aria-haspopup', 'dialog');
      element.setAttribute('aria-controls', dialogId);
      element.setAttribute('aria-expanded', 'false');
      element.setAttribute('data-dialog-trigger', '');

      var tag = element.tagName.toLowerCase();
      if (tag === 'button' || tag === 'a') return;

      element.setAttribute('role', 'button');
      element.setAttribute('tabindex', '0');
      element.addEventListener('keydown', function (event) {
        if (event.key !== 'Enter' && event.key !== ' ' && event.key !== 'Spacebar') return;
        event.preventDefault();
        element.click();
      });
    }

    function scan(root) {
      var scope = root || document;

      scope.querySelectorAll('dialog[data-video-modal]').forEach(connectDialog);

      scope.querySelectorAll('[data-video-modal-target]').forEach(function (element) {
        connectTrigger(element, element.getAttribute('data-video-modal-target'));
      });

      scope.querySelectorAll('[data-video-modal-delegate]').forEach(function (wrapper) {
        var dialogId = wrapper.getAttribute('data-video-modal-delegate');
        wrapper.querySelectorAll('[data-button-id]').forEach(function (element) {
          connectTrigger(element, dialogId);
        });
      });
    }

    document.addEventListener('shopify:section:load', function (event) {
      scan(event.target);
    });

    document.addEventListener('shopify:section:unload', function (event) {
      event.target.querySelectorAll('dialog[data-video-modal][open]').forEach(function (dialog) {
        if (window.YiseDialog) {
          window.YiseDialog.closeDialog(dialog, { restoreFocus: false });
        } else {
          dialog.close();
        }
      });
    });

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', function () {
        scan();
      });
    } else {
      scan();
    }
  })();
  } catch(e) { console.error(e); }
})();

})();
